<nav class="main-header navbar navbar-expand-md navbar-light navbar-white">
    <div *ngIf="existeEmpresa">
        <ul class="navbar-nav">
            <li class="nav-item">
                <a
                    class="nav-link"
                    (click)="mostrarMenu()"
                    data-widget="pushmenu"
                    href="#"
                    role="button">
                    <i class="fas fa-bars"></i>
                </a>
            </li>
        </ul>
    </div>
    <div *ngIf="existeEmpresa">
        <div class="custom-dropdown" *ngIf="!esUsuarioInstitucional">
            <button class="dropdown-button">Perfil</button>
            <ul class="dropdown-options">
                <li><a [routerLink]="['/editar-user']">Editar usuario</a></li>
                <li><a [routerLink]="['editar-empresa']">Editar empresa</a></li>
                <li>
                    <a [routerLink]="['editar-direccion']">Editar dirección</a>
                </li>
            </ul>
        </div>
        <div class="custom-dropdown">
            <button class="dropdown-button">
                Empresa: {{ empresaSeleccionada || 'Empresa' }}
            </button>
            <ul class="dropdown-options">
                <li *ngFor="let empresa of empresasAsociadas">
                    <a style="cursor: pointer" (click)="ingresar(empresa)">
                        {{ empresa.razonSocial }}
                    </a>
                </li>
            </ul>
        </div>
    </div>
    <ul class="navbar-nav ml-auto">
        <li class="nav-item">
            <label class="nav-link">Usuario:</label>
        </li>
        <li class="nav-item">
            <label class="nav-link">
                {{ perfilUsuario?.username + ' ' + '' }}
            </label>
        </li>
        <li class="nav-item">
            <a
                class="btn btn-success text-white topbar_color"
                (click)="logOut()">
                <i class="fas fa-sign-out-alt"></i>
                &nbsp;&nbsp;Cerrar Sesión
            </a>
        </li>
    </ul>
</nav>
